import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class UsertokenService {

  constructor() {
    this.loadTokenFromLocalStorage();
  }

  private userTokenKey = "usertoken";
  private userToken: string | null = null;

  private loadTokenFromLocalStorage() {
    let tokenFromLocalStorage: string | null = null;
    tokenFromLocalStorage = this.tryReadLocalStorageOrWarn();
    if (tokenFromLocalStorage) {
      if (this.isTokenValid(tokenFromLocalStorage)) {
        this.userToken = tokenFromLocalStorage;
      } else {
        localStorage.removeItem(this.userTokenKey);
      }
    }
  }

  private isTokenValid(token: string | null) {
    if (token == null) {
      return false;
    }
    try {
      const decodedToken = jwtDecode(token);
      if (decodedToken.exp && decodedToken.exp * 1000 > new Date().getTime()) {
        return true;
      } else {
        return false;
      }
    } catch (_e: unknown) {
      console.warn("found invalid token: ", token);
      return false;
    }
  }

  public logoutUserByUnsetToken() {
    this.userToken = null;
    try {
      localStorage.removeItem(this.userTokenKey);
    } catch (_e: unknown) {
      // that one does not matter;
    }
  }

  // persist=false haelt den Token nur im Speicher, z.B. solange der Datenschutzhinweis noch nicht bestaetigt wurde
  public setUserTokenAfterAuth(token: string, persist: boolean = true) {
    if (!this.isTokenValid(token)) {
      throw new Error("Invalid usertoken provided: " + token);
    }
    this.userToken = token;
    if (persist) {
      this.tryWriteLocalStorageOrWarn(token);
    }
  }

  /** Schreibt einen zuvor mit persist=false gesetzten Token nachtraeglich in den LocalStorage. */
  public persistToken() {
    if (this.userToken) {
      this.tryWriteLocalStorageOrWarn(this.userToken);
    }
  }

  public tryWriteLocalStorageOrWarn(token: string) {
    try {
      localStorage.setItem(this.userTokenKey, token);
      console.debug("LocalStorage updated with new token");
    } catch (e) {
      console.warn("Could not write Browsers Localstorage, session could expire", e);
    }
  }
  public tryReadLocalStorageOrWarn() {
    try {
      return localStorage.getItem(this.userTokenKey);
    } catch (e) {
      console.warn("Could not read Browsers Localstorage, session could expire", e);
    }
    return null;
  }


  public getUserToken() {
    return this.userToken;
  }

}
